import React from "react";
import { FiGrid } from "react-icons/fi";
import MiniGamePage from "./MiniGamePage";
import { fruitCutApi } from "../../utils/miniGameApi";

const FruitCut = () => (
  <MiniGamePage
    title="Fruit Cut"
    selfLabel="Fruit Cut"
    description="Manage Fruit Cut settings and view user play history."
    icon={FiGrid}
    api={fruitCutApi}
    scoreLabel="Highest Fruit Tile"
    switchTo={[
      { to: "/game-2048", label: "2048" },
      { to: "/tap-game", label: "Tap Game" },
      { to: "/boom-cards-game", label: "Boom Cards" },
    ]}
  />
);

export default FruitCut;